import React from "react";
import { Route, Switch } from "react-router-dom";
import AdminAnalytics from "./container/admin-analytics";

export default function AdminAnalyticsRoutes({ match }) {
  return (
    <Switch>
      <Route exact path={`${match.url}/`} component={AdminAnalytics} />
    </Switch>
  );
}
